@if ($safeNavigationMigration(params()?.value) !== null) {
  <div [matTooltip]="tooltip()" [matTooltipClass]="'regular-tooltip'" [matTooltipDisabled]="false" matTooltipPosition="above">
    <mat-icon class="table-icon-content">{{ 'filter_' + params()?.value }}</mat-icon>
  </div>
}
